import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function Weight({ item, index }) {
  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">192 lbs</div>
    } else {
      return <>
        <div className="col-8">Weight</div>
        <div className="col-4">192 lbs</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}